import { styled } from '@/styled-system/jsx';

export const StyledDivider = styled('div', {
  base: {
    marginTop: '20px',
    marginBottom: '20px',
    clear: 'both',
    width: '100%',
    borderWidth: '0px 0px 1px 0px',
    borderStyle: 'solid',
    borderColor: 'hpxGrey100',
  },
  variants: {
    noMargin: {
      true: {
        marginTop: '0px',
        marginBottom: '0px',
      },
    },
  },
});
